<template>
  <v-container class="pt-0" fluid>
    <base-material-card color="primary" icon="mdi-file-settings" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Relatórios Modelos</div>
      </template>
      <v-btn
        id="btn-novo-relatorio-modelo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.replace('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Relatório
      </v-btn>
      <v-text-field
        id="relatorios-modelos-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        :loading="loading"
        :hide-default-header="loading"
        :hide-default-footer="loading"
        no-data-text="Nenhum relatório disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.grupos_relatorio`]="{ item }">
          {{ item.grupos_relatorio.titulo }}
        </template>
        <template v-slot:[`item.consultas_filhas`]="{ item }">
          {{ item.consultas_filhas.length }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-edit-rel-m"
            color="gray"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.replace(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-rel-m"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-tooltip v-if="item.consultas_filhas.length" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" class="not-clickable-item" style="opacity: 0.4 !important" v-on="on">
                    <v-list-item-title>
                      <v-icon small disabled>mdi-trash-can-outline</v-icon>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <span>Esse registro não pode ser excluído pois possui relatórios filhos</span>
              </v-tooltip>
              <v-list-item v-else-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true), (dialogCreationLogData = { username: item.usuario.nome, created: item.created }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Relatório Modelo #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o relatório
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import RelatoriosModelosService from '@/services/RelatoriosModelosService';
  import powerupsActionsMixis from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete')
    },

    mixins: [powerupsActionsMixis],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    data: () => ({
      powerupService: RelatoriosModelosService,
      powerupEntityName: 'Relatório Modelo',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Grupo',
          value: 'grupos_relatorio.titulo'
        },
        {
          text: 'Nº Relatórios Filhos',
          value: 'consultas_filhas'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions'
        }
      ]
    }),

    methods: {
      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      }
    }
  };
</script>